import { ProductCardActionsModel } from "@ultracommerce/react-storefront/global/src/modules/ProductCard/Components/ProductCardActions/ProductCardActions.componentModel";
import { PublicInterface } from "@ultracommerce/react-storefront/global/src/interface/common";
import { useElementContext } from "@ultracommerce/react-storefront/global";

export const ProductCardActionsView = ({
  componentData: { type, ...rest },
  // setQuantity,
  onAddToCart,
  product
}: {
  componentData: PublicInterface<ProductCardActionsModel>;
  setQuantity: (n: number) => void;
  onAddToCart: () => void;
  product: any;
}) => {
  const { ProductModule, ProductCardModule } = useElementContext();
  const { sku, isQtyFieldRequired, isFetching } = rest;
  //@ts-ignore
  rest.product=product 
  return (
    <div className="productCard-button-container py-3">
      {isQtyFieldRequired && (
        <>
          <ProductModule.CoreComponents.ProductOutOfStock isFetching={isFetching} sku={sku} /> 
          {/*isAuthenticated() &&
          <div className="text-center border-0 bg-transparent pt-0 ">
            <div className="productCard_quantityInput">
              <ProductModule.CoreControl.ProductQuantityInput
                setQuantity={setQuantity}
                quantity={itemCount}
                sku={sku}
                showLabel={cardConfiguration?.showInputLabel}
                quantityInputType={cardConfiguration?.input?.quantityInput || "text"}
                showInventory={cardConfiguration?.input?.showInventory || false}
                dropdownLimitCount={cardConfiguration?.input?.dropdownLimitCount || 8}
              />
            </div>
          </div> 
          */}
        </>
      )}
      <ProductCardModule.CoreControl.DropdownButtons {...rest} onAddToCart={onAddToCart} />
    </div>
  );
};
